<template>
  <div>
    <div class="page-head"><div><h1>预约与签到</h1><p>按课程实际时长预占；签到时扣除对应时长</p></div></div>
    <el-row :gutter="18">
      <el-col :span="8"><div class="panel"><h3>课程列表</h3>
        <el-input v-model="filter" placeholder="搜索课程名称" clearable size="small" style="margin-bottom:12px" />
        <div class="class-list">
          <button v-for="item in filteredClasses" :key="item.id" class="class-choice" :class="{active: selectedId === item.id}" @click="select(item.id)">
            <small>{{ item.start_at }}</small><strong>{{ item.title }}</strong><span>{{ item.teacher ? item.teacher + ' · ' : '' }}{{ item.booked_count }}/{{ item.capacity }} 人</span>
          </button>
        </div>
      </div></el-col>
      <el-col :span="16"><div class="panel">
        <template v-if="selected">
          <div class="roster-head"><div><h2>{{ selected.title }}</h2><p>{{ selected.start_at }}{{ selected.teacher ? ' · ' + selected.teacher : '' }} · {{ selected.duration_min }} 分钟</p></div><el-button type="primary" size="small" :disabled="selected.status !== 'active' || isPast(selected)" @click="openBook">添加预约</el-button></div>
          <el-alert :title="`预约预占 ${selected.duration_min} 分钟；签到后正式扣减，撤销签到会返还。`" type="info" :closable="false" style="margin-bottom:14px" />
          <el-table :data="rosterRows" v-loading="loading" style="width:100%">
            <el-table-column prop="member_name" label="学员" min-width="105" />
            <el-table-column prop="phone" label="手机号" width="130" />
            <el-table-column label="剩余时长" width="105"><template slot-scope="{row}">{{ hours(row.balance) }} 小时</template></el-table-column>
            <el-table-column label="状态" width="95"><template slot-scope="{row}"><el-tag size="mini" :type="row.status==='attended'?'success':row.status==='booked'?'warning':'info'">{{ statusText(row.status) }}</el-tag></template></el-table-column>
            <el-table-column label="操作" width="160"><template slot-scope="{row}">
              <template v-if="row.status === 'booked'"><el-button size="mini" type="primary" @click="act('checkin',row)">签到</el-button><el-button size="mini" @click="act('cancel',row)">取消</el-button></template>
              <el-button v-if="row.status === 'attended'" size="mini" @click="act('undo',row)">撤销签到</el-button>
            </template></el-table-column>
          </el-table>
        </template>
        <el-empty v-else description="请先选择一节课程" />
      </div></el-col>
    </el-row>
    <el-dialog title="添加预约" :visible.sync="bookVisible" width="440px">
      <p v-if="selected" style="font-size:13px;color:#888">{{ selected.title }} · {{ selected.start_at }}</p>
      <el-select v-model="memberId" filterable placeholder="选择学员" style="width:100%">
        <el-option v-for="m in members" :key="m.id" :label="m.name + ' · 可约 ' + hours(m.available) + ' 小时'" :value="m.id" :disabled="m.available < selected.duration_min || m.status !== 1" />
      </el-select>
      <span slot="footer"><el-button @click="bookVisible=false">取消</el-button><el-button type="primary" :loading="saving" @click="book">确认预约</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
import { listClasses, roster, listMembers, bookForMember, checkin, undoCheckin, cancelBooking } from '../api'
export default {
  data: () => ({ classes: [], rosterRows: [], members: [], selectedId: null, filter: '', loading: false, saving: false, bookVisible: false, memberId: null }),
  computed: {
    selected () { return this.classes.find(x => x.id === this.selectedId) },
    filteredClasses () {
      const now = Date.now()
      const group = item => item.status === 'active' && new Date(item.start_at.replace(/-/g, '/')).getTime() > now ? 0 : 1
      return this.classes.filter(x => x.title.includes(this.filter)).slice().sort((a, b) => {
        const groupDiff = group(a) - group(b)
        if (groupDiff) return groupDiff
        return group(a) === 0 ? a.start_at.localeCompare(b.start_at) : b.start_at.localeCompare(a.start_at)
      })
    }
  },
  async created () {
    await this.loadClasses()
    const id = Number(this.$route.query.classId)
    const first = this.classes.find(x => Number(x.id) === id) ||
      this.classes.filter(x => !this.isPast(x) && x.status === 'active').sort((a, b) => a.start_at.localeCompare(b.start_at))[0] ||
      this.classes[0]
    if (first) this.select(first.id)
  },
  methods: {
    isPast (item) { return new Date(item.start_at.replace(/-/g, '/')) <= new Date() },
    statusText (status) { return ({ booked: '待签到', attended: '已签到', cancelled: '已取消' })[status] || status },
    async loadClasses () { try { this.classes = await listClasses() } catch (e) { this.$message.error(e.message) } },
    async select (id) { this.selectedId = id; await this.loadRoster() },
    async loadRoster () { this.loading = true; try { this.rosterRows = await roster(this.selectedId) } catch (e) { this.$message.error(e.message) } finally { this.loading = false } },
    async openBook () {
      this.memberId = null
      try { this.members = await listMembers(''); this.bookVisible = true } catch (e) { this.$message.error(e.message) }
    },
    async book () {
      if (!this.memberId) return this.$message.warning('请选择学员')
      this.saving = true
      try { await bookForMember(this.selectedId, this.memberId); this.bookVisible = false; this.$message.success('预约成功'); await this.refresh() }
      catch (e) { this.$message.error(e.message) } finally { this.saving = false }
    },
    async act (kind, row) {
      try {
        if (kind === 'checkin') await checkin(row.id)
        if (kind === 'undo') { await this.$confirm(`撤销后返还 ${this.selected.duration_min} 分钟，确定继续？`, '撤销签到'); await undoCheckin(row.id) }
        if (kind === 'cancel') { await this.$confirm('确定取消该学员预约？', '取消预约'); await cancelBooking(row.id) }
        this.$message.success('操作成功'); await this.refresh()
      } catch (e) { if (e !== 'cancel') this.$message.error(e.message) }
    },
    async refresh () { await this.loadClasses(); await this.loadRoster() },
    hours (minutes) { return Number((Number(minutes || 0) / 60).toFixed(2)) }
  }
}
</script>
<style scoped>
h3 { margin: 0 0 15px; font-size: 15px; }
.class-list { max-height: 650px; overflow: auto; }
.class-choice { display: block; width: 100%; border: 1px solid transparent; border-radius: 9px; padding: 13px; text-align: left; background: transparent; cursor: pointer; }
.class-choice.active { border-color: #b8c8bd; background: #f1f5f0; }
.class-choice:hover { background: #f8faf6; }
.class-choice small, .class-choice strong, .class-choice span { display: block; }
.class-choice small, .class-choice span { color: #999; font-size: 11px; }
.class-choice strong { margin: 6px 0; font-size: 13px; }
.roster-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
.roster-head h2 { margin: 0 0 7px; font-size: 20px; }
.roster-head p { margin: 0; color: #999; font-size: 12px; }
</style>
